<template>
  <div class="relative">
    <img src="@/assets/images/line/Vector 9.png" alt="lineimg" class="m-auto" />
    <div class="flex justify-center md:pt-0 lg:pt-0 pt-10">
      <div
        class="borderprimary bg-white p-4 absolute lg:top-32 md:top-32 top-0 rounded-2xl z-10"
      >
        <div class="bgcceff2 rounded-2xl">
          <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
            <p class="font-semibold text-black fsize20 sm-fsize14">
              To take this conversation forward<br />
            </p>
            <div
              class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
            >
              <base-button
                type="primary"
                class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 mx-auto md:w-auto lg:w-auto w-full"
                @click="handleContinue('contact-us')"
                >Contact Us</base-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="borderprimary p-4 rounded-2xl">
        <div class="bgcceff2 rounded-2xl">
          <div class="flex px-14 py-4">
            <p class="font-semibold text-black text-2xl">
              Lorem ipsum dolor sit <br />
              amet?
            </p>
            <div class="pl-14 items-center flex">
              <base-button
                type="primary"
                class="py-2 px-8 text-base font-bold border-2"
                >Volunteer</base-button
              >
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="relative lg:py-0 md:py-0">
      <div class="absolute bg-design4 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd4.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design-cs mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design-cs22 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>

      <div class="flex lg:gap-10 md:gap-10 px-4 md:px-0 lg:px-0">
        <div class="w-1/2 h-full flex items-center mob-hidden">
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Shaping%20Compassionate%20Workplace.jpg"
              alt="aboutus"
              class="m-auto custborderradius"
            />
          </div>
        </div>
        <div class="md:w-1/2 lg:w-1/2 w-full md:mt-0 lg:mt-0">
          <div class="relative">
            <p
              class="title sm-fsize16 lg:font-normal md:font-normal font-bold z-index--1"
            >
              Shaping Compassionate Workplaces for Caregivers
            </p>
            <!-- <p
              class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh22"
            >
              <i class="fsize15px"> </i>
            </p> -->
            <p class="subtitle lg:pt-0 md:pt-0 pt-2 lh32px sm-fsize13 sm-lh26">
              Caregiver Saathi was delighted to partner with Accenture in
              conducting a thought-leadership session on this topic which will
              impact the #futureofwork.
            </p>
            <p class="subtitle pt-4 lh32px mob-hidden">
              We had highly engaged and enthusiastic participants representing
              different industries, who came together to brainstorm ideas for
              what an ideal caregiving environment should look like. Why this is
              a cause for concern and leadership for organizations.
            </p>
            <!-- <p class="subtitle pt-4 lh32px mob-hidden">
              Admittedly, none of us were equipped to deal with so much change
              and loss. Gayatri has sent so many messages of condolences that
              the words have lost their meaning to her. She has noticed how some
              people have begun to avoid their grieving colleagues and friends
              because they simply don’t have the right words to say anymore. 
            </p>
            <p class="subtitle pt-4 lh32px mob-hidden">
              She is an HR leader and naturally everyone expected her to know
              how to deal with loss in the workplace……..
            </p> -->
          </div>
          <div class="md:pt-10 lg:pt-10 pt-6">
            <a
              href="https://www.linkedin.com/feed/update/urn:li:activity:7022179816644698113"
              ><base-button
                outline
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
                @click="handleClick"
                >Read More</base-button
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import casestudyMixin from "@/mixins/casestudy";

export default {
  mixins: [casestudyMixin],
  methods: {
    handleContinue(name) {
      this.$router.push({ name: name });
    },
    handleClick() {
      this.openCaseStudy(
        "Case Study: Learning Interventions for HR and Leaders"
      );
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h350px {
    height: 350px !important;
  }
}
</style>
